















import Video from '@/components/common/Video.vue';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { clickBanner } from '@/api/index';
@Component({
  components: {
    Swiper,
    SwiperSlide,
    Video
  }
})
export default class extends Vue {
  // 接收参数
  @Prop() public data!: object[];
  @Prop() public isActive!: boolean;
  public activeIndex:number = 0; //默认index
  swiperOptionTop = {
    spaceBetween: 0,
    prevButton: '.swiper-button-prev-banner',
    nextButton: '.swiper-button-next-banner',
    pagination: '.swiper-pagination-banner',
    paginationClickable: true,
    onSlideChangeEnd: (swiper) => {
      this.slideLeftChangeEnd(swiper.activeIndex, swiper.previousIndex);
    }
  };

  @Watch('isActive')
  activeChange(val) {
    if (!val) {
      if (this.$refs[`video${this.activeIndex}`]) {
        this.$refs[`video${this.activeIndex}`][0].suspendVideo();
      }
    }
  }

  public slideLeftChangeEnd(activeIndex, preIndex) {
    this.activeIndex = activeIndex;
    if (this.$refs[`video${preIndex}`]) {
      this.$refs[`video${preIndex}`][0].suspendVideo();
    }
  }

  public handleClick(item: any) {
    clickBanner({ id: item.id });
    if (item.anchorType === 2) {
      this.$emit('jumpToIndependent', item.anchor);
    } else if (item.anchorType === 1) {
      this.$emit('changeTab', item.anchor);
    } else if (item.anchorType === 3) {
      window.open(item.anchor);
    }
  }
}
